import React from 'react';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

export enum TextAreaType {
    TextareaAutosize = 'textareaAutosize',
    NewTextAreaAutosize = 'newTextAreaAutosize',
    TextareaFixed = 'textareaFixed',
}

export interface TextareaProps extends React.HTMLProps<HTMLTextAreaElement> {
    title?: string;
    description?: string;
    value?: string;
    defaultValue?: string;
    withoutBorders?: boolean;
    leftTitle?: boolean;
    dataTest?: string;
    boldTitle?: boolean;
    rows?: number;
    minRows?: number;
    maxRows?: number;
    isValid?: Nullable<boolean>;
    showValidStatus?: boolean;
    minHeight?: number;
    notValidText?: string;
    modifiers?: string[];
    textareaRef?: React.RefObject<HTMLTextAreaElement | null>;
    inputRef?: ((node: HTMLTextAreaElement) => void) | React.RefObject<HTMLTextAreaElement | null>;
    isRequired?: boolean;
    onHeightChange?: (height: number) => void;
    type?: TextAreaType;
    withDictation?: boolean;
    onChange?(event: React.ChangeEvent<HTMLTextAreaElement>): void;
    /** required for dictation on a controlled textarea: dictated text arrives here, not through onChange */
    onChangeText?(text: string): void;
}
